import { EllipsisOutlined } from "@payping/icons";
import { Button, Dropdown } from "@payping/web-components";
import { ButtonProps } from "@payping/web-components/components/button";
import { DropdownButtonProps } from "@payping/web-components/components/dropdown/types";
import { FC } from "react";

export interface CustomDropdownButtonProps extends DropdownButtonProps {
  block?: ButtonProps["block"];
  buttonIcon?: ButtonProps["icon"];
}

export const DropdownButton: FC<CustomDropdownButtonProps> = (props) => {
  const { className, size, trigger, buttonIcon, block, type, icon, ...otherProps } = props;

  return (
    <Dropdown.Button
      // @ts-expect-error: buttons type is wrong
      buttonsRender={([button, menuButton]: [DropdownButtonElementType, DropdownButtonElementType]) => [
        <Button key={0} {...button.props} icon={buttonIcon} block={block} type={type}>
          {button.props.children}
        </Button>,
        <Button key={1} {...menuButton.props} icon={icon || <EllipsisOutlined width={20} height={14} />} type={type}>
          {menuButton.props.children}
        </Button>,
      ]}
      className={className}
      size={size || "middle"}
      trigger={trigger}
      type={type}
      {...otherProps}
    />
  );
};
